import React from 'react';

import { Icon } from '../icons';

export const BottomChevronIcon: Icon['component'] = ({ color, style, ...props }) => {
  return (
    <svg {...props} viewBox="0 0 32 32" fill={color} style={style}>
      <path d="M5.86950977,13.8560204 C4.37857776,12.5780787 2.1339621,12.7507414 0.856020378,14.2416734 C-0.421921347,15.7326054 -0.249258604,17.9772211 1.24167341,19.2551628 L13.6860818,29.9217986 C15.017597,31.0630973 16.982403,31.0630973 18.3139182,29.9217986 L30.7583266,19.2551628 C32.2492586,17.9772211 32.4219213,15.7326054 31.1439796,14.2416734 C29.8660379,12.7507414 27.6214222,12.5780787 26.1304902,13.8560204 L16,22.5392977 L5.86950977,13.8560204 Z" />
    </svg>
  );
};
